module.exports = __webpack_public_path__ + "static/Banner-35-dd3b41bdd69f9036b124bf55a04ce8d6.png";